import { useLocalSearchParams } from 'expo-router';

import { CityEventSliceScreen } from '@/components/riviera/city-event-slice-screen';

export { generateCityEventSliceStaticParams as generateStaticParams } from '@/lib/detail/city-listings-detail';

// One city's events in a date window or one category, e.g. /en/nice/events/this-weekend
// or /fr/cannes/events/concerts — the landing pages for "what's on in nice this
// weekend" / "concert cannes". Windows exist for every city with a
// /[city]/events page; categories only above a threshold — see
// generateCityEventSliceStaticParams and src/lib/city-event-slices.ts.
export default function CityEventSliceRoute() {
  const { city, slice } = useLocalSearchParams<{ city: string; slice: string }>();
  return <CityEventSliceScreen cityId={city ?? ''} slice={slice ?? ''} />;
}
